// extracted by mini-css-extract-plugin
export default {"navBarBlock":"style_navBarBlock__5Bm40","icon":"style_icon__qA0ij"};